/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { AnyAction } from 'redux';
import { Dispatch, State } from '../../../../redux';
import { FORM_NAME } from './AddressInputForm';
import { locale, supportUSAndCanadaAddressInputs } from './config';
import AddressInputFields, {
  AddressInputDispatchProps,
  AddressInputFieldsOwnProps,
  AddressInputFieldsStateProps,
  AddressInputFormValuesShape,
} from './AddressInputFields';

import { addressUtils } from './utils';

const mapDispatchToProps = (
  dispatch: Dispatch<AnyAction>,
  _props: AddressInputFieldsOwnProps,
): AddressInputDispatchProps => ({
  clearAddressField: (field: string) => {
    dispatch(change(FORM_NAME, field, null));
  },
});

const mapStateToProps = (state: State): AddressInputFieldsStateProps => {
  const addressValues = getFormValues(FORM_NAME)(state) as AddressInputFormValuesShape;
  const addressInputCountry = addressUtils.getAddressInputType({
    locale,
    supportUSAndCanadaAddressInputs,
    countryName: addressValues && addressValues.countryName,
  });

  return {
    addressInputCountry,
  };
};

export default connect<AddressInputFieldsStateProps, AddressInputDispatchProps, AddressInputFieldsOwnProps, State>(
  mapStateToProps,
  mapDispatchToProps,
)(AddressInputFields);
